import type { RefObject } from 'react'

import { ActionRender } from './ActionsRender'
import { ActionContextProvider } from './context'
import type { IAction, IEditAction } from './interfaces'

type ActionControllerProps<T> = {
  anchorRef: RefObject<HTMLElement>
  selectedObjectsActions: IAction<T>[]
  sceneActions: IAction<T>[]
  editActions: IEditAction[]
  objects: T[]
  onActionEnd: VoidFunction
  className?: string
}

export const ActionController = <T,>({
  anchorRef,
  selectedObjectsActions,
  sceneActions,
  editActions,
  objects,
  onActionEnd,
  className = '',
}: ActionControllerProps<T>) => {
  return (
    <ActionContextProvider
      objectActions={selectedObjectsActions}
      editActions={editActions}
      sceneActions={sceneActions}
      objects={objects}
      onActionEnd={onActionEnd}>
      <ActionRender className={className} anchorRef={anchorRef} />
    </ActionContextProvider>
  )
}
